import SelectCard from "./SelectCard";
import React, { useEffect, useState } from "react";

const CardsCorreos = ({
  page,
  handleReenviar = () => { },
  selects,
  NavigationControl,
  selectGrid,
  setSelectGrid
}) => {

  const [currentActive, setCurrentActive] = useState({ id: null });

  const selectCheck = (checked, index) => {
    const avisoprivacidad = page[index].original;

    if (checked) {
      setSelectGrid(prev => [...prev, avisoprivacidad]);
      selects(avisoprivacidad, "push");
    } else {
      setSelectGrid(prev =>
        prev.filter(
          item => item.idCuentaContacto !== avisoprivacidad.idCuentaContacto
        )
      );
      selects(avisoprivacidad, "pop");
    }
  };

  return (
    <div className="cards__view">
      <div>
        {page.map((info, index) => (
          <SelectCard
            key={index}
            infoCard={info}
            index={index}
            selectCheck={selectCheck}
            checked={selectGrid.some(
              item =>
                item.idCuentaContacto === info.original.idCuentaContacto
            )}
            currentActive={currentActive}
            setCurrentActive={setCurrentActive}
            handleReenviar={handleReenviar}
          />
        ))}
      </div>

      <div className="cards__navigation">
        <NavigationControl />
      </div>
    </div>
  );
};

export default CardsCorreos;
